var m = require('mithril');
var downloadReportModalInterface = require('../../layout/components/downloadReportModalInterface');
var eventPresentation = require('../eventPresentation');
var buildEventReportDownloadOptions = require('../buildEventReportDownloadOptions');


var alarmEventCard = {};

alarmEventCard.oninit = function () {
  var ctrl = this;
}


alarmEventCard.view = function (vnode) {
  var reportName = eventPresentation.getEventReportName(vnode.attrs.eventRecord);
  var reportLocationPath = eventPresentation.getDisplayEventLocationPath(
    vnode.attrs.eventRecord,
    vnode.attrs.contextLocation
  );
  var relativeTimeLabel = eventPresentation.buildRelativeEventTimeLabel(
    vnode.attrs.eventRecord && vnode.attrs.eventRecord.start,
    vnode.attrs.referenceMoment
  );
  var durationLabel = eventPresentation.buildDurationLabel(
    vnode.attrs.eventRecord && vnode.attrs.eventRecord.start,
    vnode.attrs.eventRecord && vnode.attrs.eventRecord.end
  );
  return m(`div.w-100.ba.bw1.ph2.pv2${vnode.attrs.idx == 0 ? 
                                        vnode.attrs.selectedPage() == 1 ? 
                                          '.mr1' : '.mh1' 
                                      : 
                                        vnode.attrs.idx + 1 == vnode.attrs.recordsLength ? 
                                          vnode.attrs.lastPage() ? 
                                            '.ml1' : '.mh1' 
                                        : '.mh1'}`, [
    m('div.flex.justify-between.items-start.w-100',[
      m('div.pt1', [
        m('div', reportName),
        reportLocationPath ? m('div.f6.mt1.moon-gray', reportLocationPath) : null,
        relativeTimeLabel ? m('div.f6.mt1.silver', relativeTimeLabel) : null,
        m('div.f4.mt3', [
          m('span.moon-gray.mr1', 'Start:'),
          m('span', { style: { fontWeight: 400 } }, vnode.attrs.start)
        ]),
        m('div.f4.mt2', [
          m('span.moon-gray.mr1', 'End:'),
          m('span', { style: { fontWeight: 400 } }, vnode.attrs.end)
        ]),
        durationLabel ? m('div.f4.mt2', [
          m('span.moon-gray.mr1', 'Duration:'),
          m('span', { style: { fontWeight: 400 } }, durationLabel)
        ]) : null
      ]),
      vnode.attrs.type ?
        m('span.ba.b--blue.ph1.br2.white.dim.pointer',[
          `${vnode.attrs.type}`  
        ])
      : ''
    ]),
    (()=>{
      if(vnode.attrs.eventRecord.out_OccurredAt && vnode.attrs.eventRecord.out_OccurredAt[0].in['@rid']){
        return m('div.flex.justify-end.mt3', [
          m('div.ba.b--blue.br2.ph1.flex.items-center.justify-center.h2.w2.pointer', {
            onclick: function () {
              downloadReport(vnode);
            }
          }, [
            m('i.ion-ios-download.blue')
          ]) 
        ]);
      }
    })(),
    
  ]);
};


function downloadReport(vnode){
  downloadReportModalInterface.editDialogue(
    buildEventReportDownloadOptions(vnode.attrs.eventRecord, vnode.attrs.contextLocation)
  );
}

alarmEventCard.__testables = {
  buildEventReportDownloadOptions: buildEventReportDownloadOptions,
  buildRelativeEventTimeLabel: eventPresentation.buildRelativeEventTimeLabel,
  buildDurationLabel: eventPresentation.buildDurationLabel,
  getEventReportName: eventPresentation.getEventReportName,
  getEventLocationPath: eventPresentation.getEventLocationPath,
  getDisplayEventLocationPath: eventPresentation.getDisplayEventLocationPath
};

module.exports = alarmEventCard;
